import { faBars } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useRef, useState } from 'react'

export default function Playersidebar({ isActive, setActive }) {
    const [Sidebar, setSidebar] = useState(false);
    const dropdownRef = useRef(null);
    const buttonRef = useRef(null);

    const handleSidebar = () => {
        setSidebar(!Sidebar);
    }
    const handleClickOutside = (event) => {
        if (
            (Sidebar && dropdownRef.current && !dropdownRef.current.contains(event.target) && buttonRef.current && !buttonRef.current.contains(event.target))
        ) {
            setSidebar(false);
        }
    };

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [Sidebar]);

    const Sidebarnav = [
        { id: 'div1', icon: 'Online Shop.svg', label: 'My NFT’s' },
        { id: 'div2', icon: 'DNA Helix.svg', label: 'My DNA' },
        { id: 'div3', icon: 'Online Shop.svg', label: 'Nutrition Diet' },
        { id: 'div4', icon: 'Bill.svg', label: 'Contract Window' },
        { id: 'div5', icon: 'Magnetic Card.svg', label: 'Wallet' },
        { id: 'div6', icon: 'Change.svg', label: 'Trade Window' },
    ]

    return (
        <div>
            <div className={`hidden lg:block w-[100%] p-5 lg:p-0 text-black'}`}>
                <ul className=" space-y-2 font-medium Player-sidebar">
                    {Sidebarnav.map((item) => (
                        <button
                            key={item.id}
                            className={`w-full cursor-pointer ${isActive === item.id ? 'bg-gradient-to-r from-[#00ADF8] to-transparent to-30%' : ''}`}
                            onClick={() => setActive(item.id)}
                        >
                            <div className="py-3 px-5 2xl:py-5 2xl:text-lg rounded-md ">
                                <span>
                                    <img src={`/assets/icon/${item.icon}`} className='w-6 h-6 absolute' />
                                </span>
                                <span className="sidebar-label text-nowrap font-semibold">{item.label}</span>
                            </div>
                        </button>
                    ))}
                </ul>
            </div>
            <div className={`block lg:hidden `}>
                <FontAwesomeIcon icon={faBars} className='py-3 px-5 text-xl' onClick={handleSidebar} ref={buttonRef} />
            </div>
            {Sidebar && (
                <div className={`absolute left-3 z-50 bg-black py-3 w-[75%] md:w-[50%] rounded-xl border border-white/20`}
                    data-aos='fade-right'
                    data-aos-duration='1000'
                    ref={dropdownRef}
                    onClick={handleSidebar}
                >
                    <ul class="space-y-4 font-semibold">
                        {Sidebarnav.map((item) => (
                            <button
                                key={item.id}
                                className={`w-full ${isActive === item.id ? 'bg-gradient-to-r from-[#00ADF8] to-transparent to-60% lg:to-30%' : ''}`}
                                onClick={() => setActive(item.id)}
                            >
                                <div className="py-3 px-7 2xl:py-5 2xl:text-lg rounded-md flex items-center gap-3"><span><img src={`/assets/icon/${item.icon}`}></img></span> {item.label}</div>
                            </button>
                        ))}
                    </ul>
                </div>
            )}
        </div>
    )
}
